import whenDomReady from "when-dom-ready";

interface window {
    jhconfig: Record<string, any>
}

whenDomReady().then(() => {
    console.log("The DOM is now ready");

    const menuButton = document.querySelector<HTMLElement>('.js-menuTrigger')
    const menuItemsWrapper = document.querySelector<HTMLElement>('.site-header__navigation ul')
    const menuItems = document.querySelectorAll('.site-header__navigation ul > li')
    const menuBackgrondTriangle = document.querySelector<HTMLElement>('.js-menuBackground')
    const logoTriangle = document.querySelector('.js-logoTriangle')
    const logoText = document.querySelectorAll<HTMLElement>('.js-logoText');

    const menuLines = document.querySelectorAll<HTMLElement>('.site-header:not(.site-header-inverted) .lines')
    // const menuLineZero = document.querySelector<HTMLElement>('.line-0')
    const menuLineOne = document.querySelector<HTMLElement>('.line-1')
    const menuLineTwo = document.querySelector<HTMLElement>('.line-2')
    const menuLineThree = document.querySelector<HTMLElement>('.line-3')

    const logoLink = document.querySelector<HTMLElement>('.site-header__link');

    const config : Record<string, any> = (window as any).jhconfig;

    let menuOpen = false;

    const handleItemFadeIn = (menuItem: Element, delay: number) => {
        setTimeout(() => {
            menuItem.classList.add('fadeMenuItemIn')
        }, delay)
    }

    const handleItemFadeOut = (menuItem: Element, delay: number) => {
        setTimeout(() => {
            menuItem.classList.remove('fadeMenuItemIn')
        }, delay)
    }

    const handleFade = (direction: "in" | "out") => {
        for(let i = 0; i < menuItems.length; i++) {
            if(direction === "in") {
                const initialDelay = 2000;
                const delay = initialDelay + (i * 200);
                handleItemFadeIn(menuItems[i], delay)
            } else {
                const delay = i * 100;
                handleItemFadeOut(menuItems[i], delay)
            }
        }
    }

    menuButton.addEventListener('click', (e) => {
        e.preventDefault();

        if(!menuOpen) {
            menuBackgrondTriangle.classList.add('scaleMenuBackgroundTriangle')
            logoTriangle.classList.add('scaleLogoFillWhite')
            logoText.forEach(text => text.classList.add('scaleLogoFillPink'))

            menuItemsWrapper.style.opacity = "1";

            if(menuLines) {
                setTimeout(() => {
                    menuLines.forEach((line) => line.style.stroke = "white")
                }, 400)
            }

            setTimeout(() => {
                menuLineTwo.style.transform = "translateX(100%)";
            }, 1400)

            setTimeout(() => {
                menuLineOne.style.transform = "translateY(7px)";
                menuLineThree.style.transform = "translateY(-7px)";
            }, 1600)

            handleFade("in")

            logoLink.removeAttribute('href')

            document.body.style.overflow = "hidden";

            menuOpen = true;
        } else {
            menuLineOne.style.transform = "translateY(0)";
            menuLineThree.style.transform = "translateY(0)";
            menuItemsWrapper.style.opacity = "0";
            menuLines.forEach((line) => line.removeAttribute("style"))

            setTimeout(() => {
                menuLineTwo.style.transform = "translateX(0)";
                handleFade("out")
            }, 400)

            menuBackgrondTriangle.classList.remove('scaleMenuBackgroundTriangle')
            logoTriangle.classList.remove('scaleLogoFillWhite')
            logoText.forEach(text => text.classList.remove('scaleLogoFillPink'))

            logoLink.setAttribute('href', config.homeUrl)

            document.body.style.overflowY = "scroll";

            menuOpen = false;
        }
    })

    // Some mutation observer magic
    const submitButton = document.querySelector<HTMLElement>('.wpcf7 input[type=submit]')
    const mutationObserver = new MutationObserver((mutations) => {
        mutations.filter((mutation) => {
            const isInputOrTextArea = mutation.target.nodeName === "TEXTAREA" || mutation.target.nodeName === "INPUT"
            return isInputOrTextArea;
        }).forEach((mutation) => {
            const target = mutation.target as HTMLElement;
            console.log({mutation});
            if(Array.from(target.classList).includes("wpcf7-not-valid")) {
                submitButton.style.background = "#28283E";
                submitButton.style.borderColor = "#28283E";
            } else {
                submitButton.style.background = "#ED1F53";
                submitButton.style.borderColor = "#ED1F53";
            }
        })
    })

    mutationObserver.observe(document.querySelector<HTMLElement>('.wpcf7-form'), { subtree: true, attributes: true, attributeFilter: ['class'] })

})

